import api from '../utils/api'

/**
 * 店內自行分期 API（高階／brand 方案限定）
 *
 * 後端路由：beauty-server/business/routes/installmentRoutes.js
 * 掛載前綴：/api/businesses
 */
const base = (businessId) => `/api/businesses/${businessId}/installments`

// 分期計畫列表。params: { status, keyword, dueStart, dueEnd, page, pageSize }
export const listInstallmentPlans = (businessId, params = {}) =>
  api.get(base(businessId), { params })

// 單一計畫 + 收款明細
export const getInstallmentPlan = (businessId, planId) =>
  api.get(`${base(businessId)}/${planId}`)

// 依訂單取計畫（結帳紀錄、顧客詳情用）
export const getInstallmentPlanByOrder = (businessId, orderId) =>
  api.get(`${base(businessId)}/by-order/${orderId}`)

/**
 * 某位顧客的分期（顧客資料頁、結帳頁用）。
 * customerId 可以是 Customer._id 或平台 User._id。
 * params: { includeClosed }  true = 連已結清／已取消一起回
 * 回傳 data: { plans, summary: { outstanding, overdue, dueNow, activeCount } }
 */
export const getCustomerInstallmentPlans = (businessId, customerId, params = {}) =>
  api.get(`${base(businessId)}/by-customer/${customerId}`, { params })

/**
 * 試算排程（不寫入資料庫）。
 * payload: { totalAmount, feeAmount, periods, frequency, firstDueDate }
 */
export const previewInstallmentSchedule = (businessId, payload) =>
  api.post(`${base(businessId)}/preview`, payload)

/**
 * 登錄一期收款。
 * payload: { amount, paidDate, method, period?, paymentFee?, feeRate?, remarks? }
 *
 * paidDate 是「實際收到錢那天」，不是結帳日 —— 現金流報表以它為準。
 */
export const addInstallmentPayment = (businessId, planId, payload) =>
  api.post(`${base(businessId)}/${planId}/payments`, payload)

// 作廢一筆收款（軟性，紀錄保留）
export const voidInstallmentPayment = (businessId, paymentId, reason) =>
  api.patch(`${base(businessId)}/payments/${paymentId}/void`, { reason })

// 更新計畫：改到期日／各期金額、備註、寬限天數、單期減免
export const updateInstallmentPlan = (businessId, planId, payload) =>
  api.patch(`${base(businessId)}/${planId}`, payload)

// 取消計畫（已收款項保留）
export const cancelInstallmentPlan = (businessId, planId, reason) =>
  api.delete(`${base(businessId)}/${planId}`, { data: { reason } })
